import * as actions from '../services'
import * as types from './mutations-types'
import { addFlash } from 'src/app/components/shareds/flash/vuex/mutations-types'
import { setPagination } from 'src/app/components/shareds/pagination/vuex/mutations-types'
import { t } from 'src/utils/form'

export const loadPlans = (context, payload) => {
  return actions.getPlans(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setPlans, response.data.plans)
      context.commit(setPagination, response.data.meta)
    }
    return response
  })
}

export const inactivePlan = (context, payload) => {
  return actions.destroyPlan(payload.id)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(addFlash, { message: t(context, 'application.alert.inactive_plan', { name: response.data.plan.name }), type: 'ls-alert-success' })
      if (typeof payload.index === 'undefined') {
        context.commit(types.setPlan, response.data.plan)
      } else {
        context.commit(types.setPlanAfterUpdate, { 'index': payload.index, 'plan': response.data.plan })
      }
    }
    return response
  })
}

export const activePlan = (context, payload) => {
  var p = payload.plan
  p.active = true
  payload.plan = p

  return actions.updatePlan(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(addFlash, { message: t(context, 'application.alert.active_plan', { name: response.data.plan.name }), type: 'ls-alert-success' })
      if (typeof payload.index === 'undefined') {
        context.commit(types.setPlan, response.data.plan)
      } else {
        context.commit(types.setPlanAfterUpdate, { 'index': payload.index, 'plan': response.data.plan })
      }
    }
    return response
  })
}

export const loadPlan = (context, payload) => {
  return actions.getPlan(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setPlan, response.data.plan)
    }
    return response
  })
}

export const createPlan = (context, payload) => {
  return actions.newPlan(payload)
  .then(function (response) {
    if (response && response.status === 200 || response.status === 201) {
      context.commit(addFlash, { message: t(context, 'application.alert.created_plan_with_success'), type: 'ls-alert-success' })
      context.commit(types.setPlan, response.data.plan)
    }
    return response
  })
}

export const editPlan = (context, payload) => {
  return actions.updatePlan(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(addFlash, { message: t(context, 'application.alert.changed_plan_with_success', { name: response.data.plan.name }), type: 'ls-alert-success' })
      context.commit(types.setPlan, response.data.plan)
    }
    return response
  })
}



// WEBPACK FOOTER //
// ./src/app/pages/plans/vuex/actions.js